exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.col[data-v-68dfdb78]{\n    padding-left: 5px;\n    padding-right: 5px;\n}\n#img-focused[data-v-68dfdb78]{\n    max-height: 45vh;\n}\n", ""]);

// exports
